import React, { Component, Fragment } from 'react';
import { bool, string, shape, number } from 'prop-types';
import dynamic from 'next/dynamic';
import classNames from 'classnames';
import Image from 'components/Image';
import Heart from '/components/Icons/Heart';
import PinItButton from 'components/PinItButton';
import PrismEntryButton from 'components/PrismEntryButton';
import { imageUrl } from 'util/images';
import Modal from 'components/Modal';
import styles from './styles';

const SaveImageModal = dynamic(() => import('components/SaveImageModal'), {
  ssr: false,
  loading: () => null
});
const UserVisionBoardFirstTimeSaveModal = dynamic(
  () => import('components/UserVisionBoardFirstTimeSaveModal'),
  {
    ssr: false,
    loading: () => null
  }
);

class SaveImageToolBar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isFirstSave: false,
      hasShowSaveImageModal: false,
      imageSavedTo: undefined,
      isTooltipDismissed: true,
      savedImgId: undefined,
      isDialogDismissed: false
    };

    this.toggleSaveImageModal = this.toggleSaveImageModal.bind(this);
    this.imageSaved = this.imageSaved.bind(this);
    this.dismissTooltip = this.dismissTooltip.bind(this);
  }
  componentDidMount() {
    // we need to prevent a duplicate check of state and localstorage
    // so set state here based on whether the user has seen modal before
    // eslint-disable-next-line react/no-did-mount-set-state
    this.setState({
      isTooltipDismissed:
        window.localStorage.getItem('hasSeenSaveImageTooltip') === 'true'
    });
  }
  toggleSaveImageModal(e) {
    e.preventDefault();
    this.setState({
      hasShowSaveImageModal: !this.state.hasShowSaveImageModal
    });
  }
  imageSaved(saveObj) {
    const { title, resourceId, isFirstSave } = saveObj;
    this.setState({
      imageSavedTo: title,
      savedImgId: resourceId,
      isDialogDismissed: false
    });
    setTimeout(() => {
      this.setState({
        hasShowSaveImageModal: false,
        isDialogDismissed: true,
        isFirstSave
      });
    }, 2000);
  }
  dismissTooltip() {
    // make sure we don't show the tooltip after it has been shown once
    window.localStorage.setItem('hasSeenSaveImageTooltip', 'true');

    this.setState({ isTooltipDismissed: true });
  }
  render() {
    const {
      hashedPublicId,
      post,
      isPinnable,
      hasPrism,
      hidePrism,
      imgProps
    } = this.props;

    const { canonical } = post;

    return (
      <div className="Figure__image-toolbar">
        <style jsx>{styles}</style>
        <a
          href="#"
          className={classNames(
            'Figure__image-save-image',
            'button',
            `${this.state.savedImgId === hashedPublicId && 'saved'}`
          )}
          onClick={this.toggleSaveImageModal}
        >
          <Heart
            isOutlined={this.state.savedImgId !== hashedPublicId}
            display="inline-block"
          />
          <span>
            {this.state.savedImgId !== hashedPublicId ? 'Save' : 'Saved'}
          </span>
        </a>

        {isPinnable && canonical && (
          <PinItButton
            pageUrl={canonical}
            imageUrl={imageUrl(imgProps.url, { width: 1000 })}
            description={imgProps.alt}
            variant="imageActions"
            placement="inline"
          />
        )}
        {hasPrism && hashedPublicId && !hidePrism && (
          <PrismEntryButton imageId={hashedPublicId} entryPageUrl={canonical} />
        )}
        <Fragment>
          {this.state.hasShowSaveImageModal && (
            <Modal onClose={this.toggleSaveImageModal} cssHook="SaveImageModal">
              {hashedPublicId && (
                <SaveImageModal
                  hashedPublicId={hashedPublicId}
                  toggleSaveImageModal={this.toggleSaveImageModal}
                  imageSavedTo={this.state.imageSavedTo}
                  imageSaved={this.imageSaved}
                  dismissDialog={this.state.isDialogDismissed}
                  imgProps={imgProps}
                  post={post}
                />
              )}
            </Modal>
          )}
        </Fragment>
        {this.state.isFirstSave && !this.state.isTooltipDismissed && (
          <UserVisionBoardFirstTimeSaveModal onClose={this.dismissTooltip} />
        )}
      </div>
    );
  }
}

SaveImageToolBar.propTypes = {
  isPinnable: bool,
  hashedPublicId: string,
  post: shape({ canonical: string }).isRequired,
  hidePrism: bool,
  hasPrism: bool,
  imgProps: shape({
    url: string.isRequired,
    alt: string,
    maxSize: shape({
      width: number.isRequired,
      aspectRatio: number
    }).isRequired,
    sourceSizes: Image.propTypes.sourceSizes,
    renderOps: shape({
      resizeMode: string
    }),
    className: string.isRequired
  }).isRequired
};

SaveImageToolBar.defaultProps = {
  hashedPublicId: undefined,
  isPinnable: true,
  hasPrism: false,
  hidePrism: true
};

export default SaveImageToolBar;
